import type MailingAddress from '@consumer/types/Address'

export function formatMailingAddress (address?: MailingAddress | null, includeName = false) {
  if (!address) {
    return ''
  }

  return [
    includeName ? address.name?.trim() : null,
    address.street?.trim(),
    `${address.city?.trim()}, ${address.state?.trim()} ${address.zip?.trim()}`,
  ].filter(Boolean).join(', ')
}
